// extracted by mini-css-extract-plugin
export default {"time":"AppSidebarTimer_time_i6l91","date":"AppSidebarTimer_date_TAMzC"};